const styles = {
  item: {
    display: 'flex',
    flexDirection: {
      xs: 'row',
      md: 'column',
    },
    position: 'relative',
    paddingRight: {
      // md: '16px',
    },
    paddingLeft: {
      xs: '15px',
      md: 0,
    },
    paddingTop: {
      // md: '23px',
    },
    paddingBottom: {
      xs: '24px',
      md: 0,
    },
    minHeight: '95px',
    '&:last-child': {
      marginBottom: 0,
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      backgroundColor: 'kit.background.middlepurple',
      top: {
        xs: 4,
        md: 44,
      },
      left: 0,
      width: {
        xs: '2px',
        md: '100%',
      },
      height: {
        xs: '100%',
        md: '2px',
      },
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      backgroundColor: 'kit.background.purple',
      left: 0,
      top: {
        xs: 4,
        md: 44,
      },
      borderRadius: '50%',
      width: {
        xs: '12px',
        md: '16px',
      },
      height: {
        xs: '12px',
        md: '16px',
      },
      transform: {
        xs: 'translateX(-50%)',
        md: 'translateY(-50%)',
      },
    },
    '&:last-child::before': {
      display: 'none',
    },
  },

  time: {
    position: 'relative',
    color: 'kit.text.secondary',
    minHeight: {
      xs: 0,
      md: 50,
    },
    marginBottom: {
      xs: '4px',
      md: '12px',
    },
  },
  topic: {
    maxWidth: {
      xs: 250,
      sm: '100%',
    },
    color: 'kit.text.main',
    mt: {
      xs: 0,
      md: 3,
    },
    mb: {
      xs: 0,
      md: 2,
    },
    whiteSpace: 'break-spaces',
  },
  image: (theme) => ({
    mt: 'auto',
    [theme.breakpoints.up('xs')]: { width: 70, ml: 'auto' },
    [theme.breakpoints.up('md')]: { width: 80, ml: 0 },
  }),
  period: { maxWidth: { xs: 200, sm: '100%' } },
};

export default styles;
